export function App() {
  return (
    <div className="page">
      <header className="page__header">
        <div className="container">
          <a href="/" className="wordmark" aria-label="MAUAI — home">
            MAUAI
          </a>
        </div>
      </header>

      <main className="page__main">
        <div className="container">
          <section className="hero" aria-labelledby="hero-title">
            <p className="eyebrow">EST. MMXXVI · PORT LOUIS · MAURITIUS</p>
            <h1 id="hero-title" className="hero__title">
              An AI estate advisor for foreign buyers of Mauritius property.
            </h1>
          </section>

          <hr className="rule" aria-hidden="true" />

          <section className="value" aria-label="Approach">
            <p className="value__paragraph">
              I ground every claim in current Mauritius regulation, hedge what I cannot verify, and
              cite the as-of date on each rate and threshold I quote. When a question warrants a
              human eye, I defer to a regulated advisor by name.
            </p>
            <p className="value__paragraph value__paragraph--soft">
              The service is available bilingually, on WhatsApp and on the web, and is currently in
              a private demo phase with our first advisor partners.
            </p>
          </section>

          <hr className="rule" aria-hidden="true" />

          <section className="pillars" aria-label="Three commitments">
            <ol className="pillars__list">
              <li className="pillar">
                <span className="pillar__number" aria-hidden="true">
                  01
                </span>
                <p className="pillar__text">Grounded in current Mauritius regulation.</p>
              </li>
              <li className="pillar">
                <span className="pillar__number" aria-hidden="true">
                  02
                </span>
                <p className="pillar__text">Bilingual EN / FR, by WhatsApp or web.</p>
              </li>
              <li className="pillar">
                <span className="pillar__number" aria-hidden="true">
                  03
                </span>
                <p className="pillar__text">An advisor is always one message away.</p>
              </li>
            </ol>
          </section>

          <hr className="rule" aria-hidden="true" />

          <section className="contact" aria-label="How to reach us">
            <p className="contact__lead">For an introduction, write or message.</p>
            <ul className="contact__list">
              <li>
                <a className="contact__link" href="mailto:hello@mauai.mu">
                  <span className="contact__label">Write</span>
                  <span className="contact__value">
                    hello@mauai.mu
                    <span className="contact__arrow" aria-hidden="true">
                      →
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <a className="contact__link" href="https://wa.me/23059808380" rel="noreferrer">
                  <span className="contact__label">WhatsApp</span>
                  <span className="contact__value">
                    Message us
                    <span className="contact__arrow" aria-hidden="true">
                      →
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </section>
        </div>
      </main>

      <footer className="page__footer">
        <div className="container footer__inner">
          <p className="footer__brand">MAUAI · Port Louis, Mauritius · MMXXVI</p>
          <p className="footer__status">Currently in demo phase — by invitation.</p>
          <a className="footer__link" href="/privacy">
            Privacy
          </a>
        </div>
      </footer>
    </div>
  );
}
